module.exports = __webpack_public_path__ + "img/footer-logo.da1ad800.png";